/**
* @prop --tab-panel-background-color: Background color of the contents of the tab and the active tab of the tab bar. Defaults to `--contrast-100`.
*/

:host(limel-tab-panel) {
    --tab-panel-background-color: rgb(var(--contrast-100));
    display: block;
    height: 100%;
}

.tab-panel {
    // contains both limel-tab-bar and tab-content
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}

.tab-content {
    height: 100%;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    background-color: var(--tab-panel-background-color);
}
